import Accordion from "react-bootstrap/Accordion";
import { Truck, ChevronDown } from "react-bootstrap-icons";
import { IoCarSport } from "react-icons/io5";
import { useCallback, useEffect, useState } from "react";
import { getMyVehicles } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";
import { AddVehicle } from "./AddVehicle";

export default function VehicleSection({
  selectedVehicle,
  setSelectedVehicle,
  mode = "single",
  selectedMultipleVehicles = [],
  setMultipleVehicles = () => { },
  editMode = false
}) {

  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [activeKey, setActiveKey] = useState(null);
  const [show, setShow] = useState(false);

  // =================== FETCH ===================
  const fetchVehicles = async () => {
    setLoading(true);
    try {
      const res = await getMyVehicles();
      if (res?.success) {
        setVehicleList(res?.data || []);
      } else {
        errorAlert({ message: res?.message });
      }
    } catch (err) {
      errorAlert({
        message:
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong."
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  // 🔥 ✅ FIXED SELECT (NO BUG)
  const handleVehicleSelect = useCallback((vehicle) => {

    if (mode === "multiple") {

      setMultipleVehicles(prev => {
        const exists = prev.find(v => v._id === vehicle._id);

        if (exists) {
          return prev.filter(v => v._id !== vehicle._id);
        } else {
          return [...prev, vehicle];
        }
      });

    } else {
      setSelectedVehicle(vehicle);
      setActiveKey(null);
    }

  }, [mode, setSelectedVehicle, setMultipleVehicles]);

  // 🔥 ✅ CHECK SELECTED (NO ISSUE)
  const isSelected = (vehicle) => {
    return mode === "multiple"
      ? selectedMultipleVehicles?.some(v => v._id === vehicle._id)
      : selectedVehicle?._id === vehicle?._id;
  };

  const handleCloseModal = () => {
    setShow(false);
    fetchVehicles();
  };

  return (
    <>
      <Accordion
        className="rb-accordion mb-3"
        activeKey={activeKey}
        onSelect={(eventKey) =>
          setActiveKey(activeKey === eventKey ? null : eventKey)
        }
      >

        <Accordion.Item eventKey="0" className="vehicle-card">

          {/* HEADER */}
          <Accordion.Header className="vehicle-acc-header">

            <div className="header-wrapper">

              <div className="vehicle-header-top">
                <div className="left">
                  <IoCarSport size={24} color="#2563eb" />
                  <span>Vehicle</span>
                </div>

                {!editMode && (
                  <div
                    className="add-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShow(true);
                    }}
                  >
                    + Add Vehicle
                  </div>
                )}
              </div>

              {/* 🔥 HEADER STATE */}
              {mode === "multiple" ? (
                <div className="vehicle-box">
                  <strong>
                    {selectedMultipleVehicles.length > 0
                      ? `${selectedMultipleVehicles.length} Vehicles Selected`
                      : "Select Vehicles"}
                  </strong>
                  <div className="right">
                    <ChevronDown />
                  </div>
                </div>
              ) : (
                selectedVehicle?._id ? (
                  <div className="vehicle-box">
                    <div className="vehicle-icon">
                      <Truck size={22} color="#fff" />
                    </div>
                    <div className="info">
                      <h6>{selectedVehicle?.vehicleName}</h6>
                      <p>{selectedVehicle?.licensePlate}</p>
                    </div>
                    <div className="right">
                      <span className="selected">Selected ✓</span>
                      <ChevronDown />
                    </div>
                  </div>
                ) : (
                  <div className="vehicle-box">
                    <strong>Please select vehicle</strong>
                    <div className="right">
                      <ChevronDown />
                    </div>
                  </div>
                )
              )}

            </div>
          </Accordion.Header>

          {/* BODY */}
          <Accordion.Body>
            <div className="vehicle-body">

              {vehicleList?.length > 0 ? (
                vehicleList.map((vehicle) => (
                  <div
                    key={vehicle._id}
                    className="vehicle-box mb-3 cursor-pointer"
                    onClick={() => handleVehicleSelect(vehicle)}
                  >
                    <div className="vehicle-icon">
                      <Truck size={22} color="#fff" />
                    </div>

                    <div className="info">
                      <h6>{vehicle.vehicleName}</h6>
                      <p>{vehicle.licensePlate}</p>
                    </div>

                    {isSelected(vehicle) && (
                      <div className="right">
                        <span className="selected">Selected ✓</span>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p>No Vehicle Found</p>
              )}

            </div>
          </Accordion.Body>

        </Accordion.Item>
      </Accordion>

      {show && <AddVehicle show={show} closeModal={handleCloseModal} />}
    </>
  );
}